import { SummaryStatistics } from 'modules/mailing/email-statistics/types/email-statistics-interface'
import { getPercentAndAmountStatistic } from 'shared/utils/get-percent-and-amount-statistic'

export const getStatistic = (stats?: SummaryStatistics) => ({
  openRate: getPercentAndAmountStatistic({
    numberOfActions: stats?.openedAmount,
    totalNumber: stats?.sentAmount,
  }),
  spamReportRate: getPercentAndAmountStatistic({
    numberOfActions: stats?.spamReportAmount,
    totalNumber: stats?.openedAmountWithEnabledSpamReportFeedback,
  }),
  clicksRate: getPercentAndAmountStatistic({
    numberOfActions: stats?.clickedAmount,
    totalNumber: stats?.sentAmount,
  }),
  bouncedRate: getPercentAndAmountStatistic({
    numberOfActions: stats?.bouncedAmount,
    totalNumber: stats?.sentAmount,
  }),
})
